import classnames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import { CONTEXT, SHOP_MAIN_PAGE_URL } from '../config';
import styles from './Menu.module.less';
import { setActiveMenu } from '../actions/layout';
import { logPostInfo, logging } from '../actions/log';
import { cleanSearchRecommend } from '../actions/search';
import { categoryKeys, SCROLL_PAGE } from '../constants/storageKeys';
import { MENUS } from '../constants/layout';
import { useAliveController } from 'react-activation';

const selectActiveMenu = createSelector(
  state => state.layout,
  layout => layout.activeMenu,
);
const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSIMStatusVT = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.isvteabled,
);
const selectIsShowMenuSpot = createSelector(
  state => state.layout,
  native => native.isShowMenuSpot,
);

const logSourcePage = {
  [`${CONTEXT}/recommend`]: 'Recommend',
  [`${CONTEXT}/category`]: 'Classify',
  [`${CONTEXT}/topn`]: 'Rank',
  [`${CONTEXT}/game`]: 'Game',
  [`${CONTEXT}/education`]: 'Education',
  [`${CONTEXT}/work`]: 'Work',
  [`${CONTEXT}/shop`]: 'Shop',
  [`${CONTEXT}/update`]: 'Update',
  [`${CONTEXT}/uninstall`]: 'Uninstall',
  [`${CONTEXT}/arecommend`]: 'ARecommend',
  [`${CONTEXT}/acategory`]: 'ACategory',
  [`${CONTEXT}/android/detail`]: 'AndroidDetail',

  [`${CONTEXT}/detail`]: 'AppDetail',
  [`${CONTEXT}/search`]: 'Search',
  [`${CONTEXT}/guesslikesmore`]: 'Reco_Guess_More',
  [`${CONTEXT}/topnmore`]: 'Rank_More_Page',
  [`${CONTEXT}/dt`]: 'dt',

  [`${CONTEXT}/wprecommend`]: 'wprecommend',
  [`${CONTEXT}/wpcategory`]: 'wpcategory',
  [`${CONTEXT}/wpmine`]: 'wpmine',
  [`${CONTEXT}/wpdetail`]: 'wpdetail',
  [`${CONTEXT}/wpzt`]: 'wpzt',
};

export default memo(() => {
  const location = useLocation();
  const dispatch = useDispatch();
  const activeMenu = useSelector(selectActiveMenu);
  const upgradeSoftsData = useSelector(selectUpgradeSofts);
  const logInfoData = useSelector(selectLogInfo);
  const isVTEabled = useSelector(selectSIMStatusVT); // 电脑VT是否打开
  const isShowMenuSpot = useSelector(selectIsShowMenuSpot); // 是否展示菜单上小红点

  const [logFlag, setLogFlag] = useState(false); // 只报一次更新列表的桩

  const { drop, refresh } = useAliveController();

  const getSP = useCallback(() => {
    const { pathname } = location;
    let source_p = 'null';
    if (logSourcePage[pathname]) {
      source_p = logSourcePage[pathname];
    } else if (pathname.indexOf('/detail') > -1) {
      source_p = logSourcePage[`${CONTEXT}/detail`];
    } else if (pathname.indexOf('/search') > -1) {
      source_p = logSourcePage[`${CONTEXT}/search`];
    } else if (pathname.indexOf('/topnmore') > -1) {
      source_p = logSourcePage[`${CONTEXT}/topnmore`];
    }
    return source_p;
  }, []);

  const handleActive = useCallback(pathname => {
    const logAction = logSourcePage[pathname] ? `Menu_${logSourcePage[pathname]}` : `Menu_shop`;
    // menu切换打桩
    dispatch(
      logging({
        category: 'C',
        action: logAction,
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source || getSP(),
        source_pp: logInfoData.source_p,
      }),
    );
    if (pathname === 'shop') {
      window.open(SHOP_MAIN_PAGE_URL);
      return;
    }

    dispatch(setActiveMenu(pathname));
    dispatch(cleanSearchRecommend());

    // 当菜单点击分类 初始化一次sessionStorage中存储的分类数据
    if (pathname.indexOf('/acategory') > -1) {
      sessionStorage.setItem(
        categoryKeys.A_CODE_CLASS_TAG,
        JSON.stringify({
          code: 'game',
          classId: '',
          className: '',
          tagId: '-1',
          tagName: '全部',
          tags: [],
          pageNum: 1,
          skip: 0,
          limit: 30,
        }),
      );
    }
    if (pathname.indexOf('/category') > -1) {
      sessionStorage.setItem(
        categoryKeys.CODE_CLASS_TAG,
        JSON.stringify({
          code: 'soft',
          classId: '-1',
          className: '全部',
          tagId: '-1',
          tagName: '全部',
          tags: [],
          pageNum: 1,
          skip: 0,
          limit: 30,
        }),
      );
    }
    // 每次点击菜单清空sessionStorage保存的页面停留位置，页面滚动到顶部
    sessionStorage.setItem(SCROLL_PAGE, JSON.stringify({}));
    document.getElementById('container_content').scrollTo(0, 0);
  }, []);

  // 产品需要  当更新数据获取得到了，就打桩上报可更新数目
  useEffect(() => {
    if (upgradeSoftsData !== null && logFlag === false) {
      setLogFlag(true);
      const pc_softids = [];
      const a_pkg = [];
      upgradeSoftsData.forEach(soft => {
        if (soft.androidType === '1') {
          a_pkg.push(soft.packageName);
        } else {
          pc_softids.push(soft.softID);
        }
      });
      dispatch(
        logging({
          category: 'I',
          action: 'UpdateApp',
          label: '',
          param2: {
            update_total: upgradeSoftsData.length,
            pc_update_total: pc_softids.length,
            pc_update_softid: pc_softids.join(', '),
            a_update_total: a_pkg.length,
            a_update_pkg: a_pkg.join(', '),
          },
        }),
      );
    }
  }, [dispatch, upgradeSoftsData]);

  useEffect(() => {
    const { pathname } = location;
    if (pathname && pathname.split(`${CONTEXT}/`)[1]) {
      const currPage = pathname && pathname.split(`${CONTEXT}/`)[1].split('/')[0];
      if (MENUS.indexOf(currPage) > -1) {
        dispatch(setActiveMenu(pathname));
      }
    }
  }, [location.pathname]);

  return (
    <div className={styles.menu}>
      <Link
        to={`${CONTEXT}/recommend`}
        className={classnames('item', {
          active: `${CONTEXT}/recommend` === activeMenu || `${CONTEXT}/recommend/` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/recommend`);
          drop('RecoEducation');
        }}
      >
        <i className="icon iconfont icon-menu_reco" />
        <span className="tit">推荐</span>
      </Link>
      <Link
        to={`${CONTEXT}/game/gameSelect`}
        className={classnames('item', { active: activeMenu.indexOf(`${CONTEXT}/game`) > -1 })}
        onClick={() => {
          handleActive(`${CONTEXT}/game/gameSelect`);
        }}
      >
        <i className="icon iconfont icon-menu_game" />
        <span className="tit">游戏</span>
        {+new Date('2021-1-01 23:59:59') - +new Date() > 0 && <span className="pointer_new" />}
      </Link>

      {/* <Link
        to={`${CONTEXT}/edurecommend`}
        className={classnames('item', {
          active:
            activeMenu.indexOf(`${CONTEXT}/edurecommend`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/educategory`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/edumine`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/edudetail`) > -1,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/edurecommend`);
        }}
      >
        <i className="icon iconfont icon-menu_education" />
        <span className="tit">教育new</span>
      </Link> */}

      <Link
        to={`${CONTEXT}/education`}
        className={classnames('item', {
          active:
            activeMenu.indexOf(`${CONTEXT}/edurecommend`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/educategory`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/edumine`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/edudetail`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/education`) > -1,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/education`);
          refresh('RecoEducation');
        }}
      >
        <i className="icon iconfont icon-menu_education" />
        <span className="tit">教育</span>
      </Link>
      <Link
        to={`${CONTEXT}/work`}
        className={classnames('item', { active: `${CONTEXT}/work` === activeMenu })}
        onClick={() => {
          handleActive(`${CONTEXT}/work`);
        }}
      >
        <i className="icon iconfont icon-menu_work" />
        <span className="tit">办公</span>
      </Link>
      {/* <Link
        to={`${CONTEXT}/topn`}
        className={classnames('item', {
          active: `${CONTEXT}/topn` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/topn`);
        }}
      >
        <i className="icon iconfont icon-topn" />
        <span className="tit">排行</span>
      </Link> */}

      <Link
        to={`${CONTEXT}/category`}
        className={classnames('item', {
          active: `${CONTEXT}/category` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/category`);
        }}
      >
        <i className="icon iconfont icon-menu_category" />
        <span className="tit">分类</span>
      </Link>
      <Link
        to={`${CONTEXT}/wprecommend`}
        className={classnames('item', {
          active:
            activeMenu.indexOf(`${CONTEXT}/wprecommend`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/wpcategory`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/wpmine`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/wpdetail`) > -1 ||
            activeMenu.indexOf(`${CONTEXT}/wpzt`) > -1,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/wprecommend`);
        }}
      >
        <i className="icon iconfont icon-menu_wallpaper" />
        <span className="tit">壁纸</span>
        {+new Date('2020-10-31 23:59:59') - +new Date() > 0 && <span className="pointer_new" />}
      </Link>
      {/* {isVTEabled && (
        <React.Fragment>
          <Link
            to={`${CONTEXT}/arecommend`}
            className={classnames('item', {
              active:
                `${CONTEXT}/arecommend` === activeMenu || `${CONTEXT}/acategory` === activeMenu,
            })}
            onClick={() => {
              handleActive(`${CONTEXT}/arecommend`);
            }}
          >
            <i className="icon iconfont icon-menu_android" />
            <span className="tit">手游助手</span>
            {+new Date('2020-06-12 23:59:59') - +new Date() > 0 && <span className="pointer_hot" />}
          </Link>
        </React.Fragment>
      )} */}
      <Link
        to={`${CONTEXT}/update`}
        className={classnames('item', {
          active: `${CONTEXT}/update` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/update`);
        }}
      >
        <i className="icon iconfont icon-menu_update" />
        <span className="tit">软件升级</span>
        {upgradeSoftsData && upgradeSoftsData.length > 0 && (
          <span className="pointer">{upgradeSoftsData.length}</span>
        )}
      </Link>
      <Link
        to={`${CONTEXT}/uninstall`}
        className={classnames('item', {
          active: `${CONTEXT}/uninstall` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/uninstall`);
        }}
      >
        <i className="icon iconfont icon-menu_mysoft" />
        <span className="tit">我的软件</span>
        {isShowMenuSpot && <span className="spot" />}
      </Link>

      {/* <Link
        to={`${CONTEXT}/othertest`}
        className={classnames('item', {
          active: `${CONTEXT}/otherpage` === activeMenu || `${CONTEXT}/othertest` === activeMenu,
        })}
        onClick={() => {
          handleActive(`${CONTEXT}/othertest`);
        }}
      >
        <i className="icon iconfont icon-menu_education" />
        <span className="tit">Other Page</span>
      </Link> */}
    </div>
  );
});
